import { Actions } from './map-analytics.actions'
import { fromJS } from 'immutable'
import * as industriesTypes from './map-analytics.types'

export const initialState = fromJS({
  dashboards: {
    isLoading: false,
    data: [],
  },
  dashboardData: {
    isLoading: false,
    data: {},
  },
})

export function mapAnalyticsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case industriesTypes.FETCH_DASHBOARDS_REQUEST: {
      return state.setIn(['dashboards', 'isLoading'], true)
    }

    case industriesTypes.FETCH_DASHBOARDS_SUCCESS: {
      return state
        .setIn(['dashboards', 'isLoading'], false)
        .setIn(['dashboards', 'data'], fromJS(action.payload))
    }

    case industriesTypes.FETCH_DASHBOARDS_FAILURE: {
      return state.setIn(['dashboards', 'isLoading'], false)
    }

    case industriesTypes.FETCH_DASHBOARD_DATA_REQUEST: {
      return state.setIn(['dashboardData', 'isLoading'], true)
    }

    case industriesTypes.FETCH_DASHBOARD_DATA_SUCCESS: {
      return state
        .setIn(['dashboardData', 'isLoading'], false)
        .setIn(
          ['dashboardData', 'data'],
          fromJS(
            action.payload.reduce(
              (acc: any, item: any) => ({ ...acc, [item.featureId]: item }),
              {},
            ),
          ),
        )
    }

    case industriesTypes.FETCH_DASHBOARD_DATA_FAILURE: {
      return state.setIn(['dashboardData', 'isLoading'], false)
    }

    case industriesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case industriesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
